import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'
import { GroupList } from 'pui-react-lists'
import Waypoint from 'react-waypoint'
import RefreshIndicator from 'material-ui/RefreshIndicator'
import ConversationsListItem from './ConversationsListItem'
import TextUnknownButton from './TextUnknownButton'
import { choosePhoneNumberFormatter } from '../../services/formatters'
import { renderAlert } from '../../services/render-alert'
import * as ConvoMsgActions from '../../state/actions/conversations-messages'
import styles from './styles/ConversationsList'

class ConversationsList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      convoHashCode: 0,
      initialFetch: true,
    }
  }

  async componentDidMount() {
    try {
      const {
        activeStatus,
        conversations,
        fetchNextConversationPage,
        pageNum,
        queryParams,
      } = this.props
      const convoHashCode = conversations.hashCode()
      await fetchNextConversationPage(pageNum, activeStatus, queryParams)
      this.setInitialState(convoHashCode)
    } catch (e) {
      renderAlert(e.message, 'error')
    }
  }

  componentWillReceiveProps = (nextProps) => {
    if (
      nextProps.conversations.size !== this.props.conversations.size ||
      nextProps.activeStatus !== this.props.activeStatus
    ) {
      this.setState({
        convoHashCode: nextProps.conversations.hashCode(),
      })
    }
  }

  setInitialState = convoHashCode =>
    this.setState({ ...this.state, convoHashCode, initialFetch: false })

  fetchNextConvoPage = () => {
    const {
      pageNum,
      activeStatus,
      totalPages,
      conversations,
      fetchNextConversationPage,
      queryParams,
    } = this.props
    const nextPageNum = pageNum + 1
    if (conversations.isEmpty()) {
      fetchNextConversationPage(pageNum, activeStatus, queryParams)
    } else if (pageNum <= totalPages) {
      fetchNextConversationPage(nextPageNum, activeStatus, queryParams)
    }
  }

  loaderStyles = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  }

  render() {
    const {
      conversations,
      countryCode,
      emailOnly,
      handleTextUnknownClick,
      handleConvoClick,
      hasReminders,
      hasTextingOnly,
      hasUnknownTexting,
      isFetching,
      selectedConversationId,
      height,
    } = this.props
    const { initialFetch } = this.state
    const formatPhoneNumber = choosePhoneNumberFormatter(countryCode)
    const isTops = process.env.REACT_APP_IS_TOPS
    const showTextUnknownButton = !emailOnly && (
      (!isTops && hasReminders)
      || hasUnknownTexting
      || hasTextingOnly
    )

    let list = {}

    if (conversations.isEmpty()) {
      list.size = 0
    } else {
      list = conversations.map(conversation => (
        <ConversationsListItem
          key={conversation.id}
          data={conversation}
          isSelected={conversation.id === selectedConversationId}
          handleConvoClick={handleConvoClick}
          formatPhoneNumber={formatPhoneNumber}
        />
      ))
    }

    const convoListStyle = { height: `calc(${height} - 55px)`, ...styles.conversationsList }

    return (
      <div className="conversationsList" style={convoListStyle}>
        {initialFetch ? (
          <div>
            <RefreshIndicator
              size={50}
              top={0}
              left={0}
              status="loading"
              style={this.loaderStyles}
            />
          </div>
        ) : (
          <div>
            {showTextUnknownButton && (
              <TextUnknownButton onClick={handleTextUnknownClick} />
            )}
            <div
              className="conversationsGroupList"
              style={styles.conversationsGroupList}
            >
              {list.size ? (
                <GroupList style={styles.conversationItemsList}>
                  {list}
                </GroupList>
              ) : (
                <div style={styles.noConvosMsg}>
                  You have no messages in your inbox
                </div>
              )}
            </div>
            {isFetching && (
              <div style={styles.conversationLoaderBox}>
                <RefreshIndicator
                  size={50}
                  top={0}
                  left={0}
                  status="loading"
                  style={this.loaderStyles}
                />
              </div>
            )}
            {!initialFetch && !conversations.isEmpty() && !isFetching && (
              <div className="Waypoint" style={styles.conversationWaypoint}>
                <Waypoint
                  key={this.state.convoHashCode}
                  onEnter={this.fetchNextConvoPage}
                />
              </div>
            )}
          </div>
        )}
      </div>
    )
  }
}

ConversationsList.propTypes = {
  handleConvoClick: PropTypes.func.isRequired,
  pageNum: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  convoType: PropTypes.oneOf(['allConvos', 'activeConvos']).isRequired,
  emailOnly: PropTypes.bool.isRequired,
  fetchNextConversationPage: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  activeStatus: PropTypes.oneOf(['all', 'active']).isRequired,
  countryCode: PropTypes.string.isRequired,
  hasReminders: PropTypes.bool.isRequired,
  hasTextingOnly: PropTypes.bool.isRequired,
  handleTextUnknownClick: PropTypes.func.isRequired,
  selectedConversationId: PropTypes.number,
  hasUnknownTexting: PropTypes.bool.isRequired,
  queryParams: PropTypes.objectOf(PropTypes.string),
}

const mapStateToProps = ({ account, conversations }, { convoType }) => {
  if (convoType === 'activeConvos') {
    const { byId, activeConvos } = conversations

    return {
      pageNum: activeConvos.pageNum,
      totalPages: activeConvos.totalPages,
      conversations: activeConvos.idsList.map(id => byId[id]),
      isFetching: activeConvos.isFetching,
      activeStatus: 'active',
      countryCode: account.user.countryCode,
      hasReminders: account.auth.hasReminders,
      hasTextingOnly: account.auth.hasTextingOnly,
      hasUnknownTexting: account.auth.hasUnknownTexting,
    }
  } else if (convoType === 'allConvos') {
    const { byId, allConvos } = conversations

    return {
      pageNum: allConvos.pageNum,
      totalPages: allConvos.totalPages,
      conversations: allConvos.idsList.map(id => byId[id]),
      isFetching: allConvos.isFetching,
      activeStatus: 'all',
      countryCode: account.user.countryCode,
      hasReminders: account.auth.hasReminders,
      hasTextingOnly: account.auth.hasTextingOnly,
      hasUnknownTexting: account.auth.hasUnknownTexting,
    }
  }
  return null
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchNextConversationPage: ConvoMsgActions.fetchNextConversationPage,
    },
    dispatch,
  )

export default connect(mapStateToProps, mapDispatchToProps)(ConversationsList)



// WEBPACK FOOTER //
// ./src/components/Messages/ConversationsList.js